import { render, staticRenderFns } from "./ObjectBlock.vue?vue&type=template&id=f65f81b6&scoped=true&"
import script from "./ObjectBlock.vue?vue&type=script&lang=js&"
export * from "./ObjectBlock.vue?vue&type=script&lang=js&"
import style0 from "./ObjectBlock.vue?vue&type=style&index=0&id=f65f81b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f81b6",
  null
  
)

export default component.exports